import { defineStore } from "pinia";
import { ref } from "vue";
import providentService from "@/services/finance/provident.service";
import { toast } from "@/utils/toast";
import { MODULE_KEYS } from "@/config/modules-registry";
import { guardPlanModule } from "@/utils/planAccess";

export const useProvidentStore = defineStore("provident", () => {
  const items = ref([]);
  const loading = ref(false);
  const loadingForCreate= ref(false);
  const loadingForDelete = ref(false);
  const pagination = ref({});
  const error = ref(null);

  async function fetchAll(params = {}) {
    if (!(await guardPlanModule(MODULE_KEYS.FA_SALES))) {
      items.value = [];
      return;
    }

    loading.value = true;
    try {
      const res = await providentService.list(params);
      items.value = res.data.data;
      pagination.value = res.data;
    } catch (e) {
      error.value = e;
    } finally {
      loading.value = false;
    }
  }

  async function createItem(payload) {
    loadingForCreate.value = true;
    try {
      await providentService.create(payload);
      toast.success("Provident fund added");
      fetchAll();
    } catch (e) {
      error.value = e;
    } finally {
      loadingForCreate.value = false;
    }
  }

  async function updateItem(id, payload) {
    loadingForCreate.value = true;
    try {
      await providentService.update(id, payload);
      toast.success("Updated");
      fetchAll();
    } catch (e) {
      error.value = e;
    } finally {
      loadingForCreate.value = false;
    }
  }

  async function deleteItem(id) {
    loadingForDelete.value = true;
    try {
      await providentService.delete(id);
      toast.success("Deleted");
      fetchAll();
    } catch (e) {
      error.value = e;
    } finally {
      loadingForDelete.value = false;
    }
  }

  return {
    items,
    pagination,
    loading,
    loadingForCreate,
    loadingForDelete,
    fetchAll,
    createItem,
    updateItem,
    deleteItem,
  };
});
